import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Table } from '../../components/Table';
import Cookies from 'js-cookie';

const Wrapper = styled.div`
    width: 100%;
    background: ${({ theme }) => theme.colors.background};;
    .flex {
        display: flex;
        justify-content: space-between;
    }
`;

const Title = styled.div`
    color: ${({ theme }) => theme.colors.primaryBlack};
    font-size: ${({ theme }) => theme.fontSize.large};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    margin-bottom: 4px;
`;

const Description = styled.div`
    color: ${({ theme }) => theme.colors.secondaryBlack};
    font-size: ${({ theme }) => theme.fontSize.small};
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

const Header = styled.div`
    margin-bottom: 40px;
`;

interface Props {
    name: string;
    description: string;
}

export const PageComponent: React.FC<Props> = ({name, description}) => {
    const [count, setCount] = useState(0);
    const [user, setUser] = useState('');

    // const appKey = useMemo(() => {
    //     return Cookies.get('app_key');
    // }, [])
    
    // const uToken = useMemo(() => {
    //     return Cookies.get('utoken');
    // }, [])

    // console.log({appKey, uToken})

    // useEffect(() => {
    //     if (appKey && uToken) {
    //         fetch(`https://api.smsbump.com/smsapp/${appKey}/users/getData?utoken=${uToken}`, {
    //             method: "GET",
    //             headers: {
    //                 'x-introspection-authenticated': 'true',
    //                 'x-introspection-store-id': `${appKey}`,
    //                 'x-smsbump-environment': 'dev',
    //                 'x-smsbump-platform': 'shopify',
    //             },
    //         })
    //          .then((response) => {
    //             return response.json();
    //          })
    //          .then((data) => {
    //             setUser(data?.user?.user_name?.first)
    //          })
    //     }
    // }, [appKey, uToken]);

    return (
        <Wrapper>
            <Header>          
                <Title>Email & SMS Flows</Title>
                <Description>Activate automated text messages to increase loyalty program awareness and participation using Yotpo SMSBump.</Description>
            </Header>
            <Table />
        </Wrapper>
    )
}